export default __webpack_public_path__ + "static/media/icn_zonal_config.f6593733.svg";